/*
 * QuotationsSearch Messages
 *
 * This contains all the text for the QuotationsSearch container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.QuotationsSearch';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Cerca preventivi',
  },
  customer_field_label: {
    id: `${scope}.customer_field_label`,
    defaultMessage: 'Ricerca per cliente',
  },
  customer_field_placeholder: {
    id: `${scope}.customer_field_placeholder`,
    defaultMessage: 'Nome, cognome, ragione sociale o email',
  },
  fiscal_code_field_placeholder: {
    id: `${scope}.fiscal_code_field_label`,
    defaultMessage: 'Codice fiscale / partita IVA',
  },
  quotation_id_field_placeholder: {
    id: `${scope}.quotations_id_field_label`,
    defaultMessage: 'Numero preventivo',
  },
  agent_id_field_placeholder: {
    id: `${scope}.agent_id_field_placeholder`,
    defaultMessage: 'Agente',
  },
  search: {
    id: `${scope}.search`,
    defaultMessage: 'Cerca',
  },
});
